// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_REQUEST,
    MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_SUCCESS,
    MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_FAILURE,
    MORTGAGE_REQUEST_CALCULATE_PROGRESS_BAR_SUCCESS
} = require('constants/actionTypes');
const mortgageRequestStates = require('constants/mortgageRequestStates');

const requestProgressBarInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_REQUEST
});

const requestProgressBarSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_SUCCESS,
    data: data
});

const requestProgressBarFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_PROGRESS_BAR_FAILURE,
    data: {
        error
    }
});

const calculateProgressBarSuccess = (progress) => ({
    type: MORTGAGE_REQUEST_CALCULATE_PROGRESS_BAR_SUCCESS,
    progress
});

const requestProgress = (idExpediente) => (dispatch) => {
    dispatch(requestProgressBarInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('mortgageRequestProgressBar', { idExpediente: idExpediente }))
        .then(response => dispatch(requestProgressBarSuccess(response)))
        .catch(error => dispatch(requestProgressBarFailure(error)));
};

const calculateProgress = (estado) => (dispatch) => {
    /*
        10% - Terminada la simulacion
        40% - Terminada la carga de titulares
        65% - Terminada la carga de vivienda
        90% - Terminada la preparaciòn de firma
        100% - Concedida
    */

    let progress;
    switch (estado) {
        case mortgageRequestStates.SIMULACION:
        case mortgageRequestStates.RESULTADO_SIMULACION:
        case mortgageRequestStates.PRE_APROBACION:
        case mortgageRequestStates.PRE_APROBADO:
        case mortgageRequestStates.SOLIC_PRESTAMO:
        case mortgageRequestStates.APORTAR_DOC:
        case mortgageRequestStates.AUT_CIRBE:
        case mortgageRequestStates.AUT_CIRBE_CO:
        case mortgageRequestStates.WAIT_CIRBE_COT:
        case mortgageRequestStates.CONFIRMA_DATOS_T2:
            progress = 10;
            break;
        case mortgageRequestStates.DATOS_VIV:
        case mortgageRequestStates.TRAMITAR_NOTAS:
        case mortgageRequestStates.TRAMITAR_NS:
        case mortgageRequestStates.PROBLEMA_NS:
        case mortgageRequestStates.PEND_TASACION:
        case mortgageRequestStates.TRAMITAR_TAS:
        case mortgageRequestStates.WAIT_DICTAMEN:
        case mortgageRequestStates.ANALISIS_TAS:
            progress = 40;
            break;
        case mortgageRequestStates.APERTURA_CUENTA:
        case mortgageRequestStates.APROBADO_RIESGOS:
        case mortgageRequestStates.PROV_FONDOS:
        case mortgageRequestStates.ESPERA_DOC_FIRMA:
        case mortgageRequestStates.ESPERA_ACTA_NOTARIO:
        case mortgageRequestStates.GESTION_FECHA_FIRMA:
        case mortgageRequestStates.PEND_MMPP:
        case mortgageRequestStates.PEND_SALDO:
        case mortgageRequestStates.OFRECER_FINANCIACION_GASTOS:
        case mortgageRequestStates.GENERANDO_OV:
        case mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR:
            progress = 65;
            break;
        case mortgageRequestStates.PEND_FIRMA:
            progress = 90;
            break;
        case mortgageRequestStates.FIRMADO:
            progress = 100;
            break;
        case mortgageRequestStates.MODEL_CORRECT:
            progress = 10;
            break;
        case mortgageRequestStates.ERROR_BUREAUS:
            progress = 10;
            break;
        default:
            progress = 10;
    }
    dispatch(calculateProgressBarSuccess(progress));
};

module.exports = {
    requestProgress,
    calculateProgress
};
